import React from "react";
import { Row, Col } from "antd";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import UmkSliderContainer from "../../components/unimake-slider-container/UmkSliderContainer";
import ContatoComponent from "./components/ContatoComponent";

class UnicoMaterialEletricoPage extends React.Component<any, any> {
	state = {
		logoUnicoEletricos: require("../../assets/img/products/topo/unico-materiais-eletricos.png"),
	};

	constructor(props: any) {
		super(props);
	}

	componentDidMount() {
		document.title = "Unimake Software - Materiais Elétricos";
	}

	render() {
		return (
			<>
				<div className="topo-border-rounded color-materiais-eletricos">
					<Row align="middle" justify="space-around">
						<Col
							lg={{ order: 1, span: 10, offset: 2 }}
							xs={{ order: 2, span: 20 }}
							xxl={{ order: 1, span: 7, offset: 5 }}>
							<h1 className="hidden-xs hidden-sm hidden-md">Único ERP </h1>
							<h2 className="hidden-xs hidden-sm hidden-md">Materiais Elétricos</h2>

							<p className="subtitulo">A organização que fará sua empresa crescer sem limites!</p>
						</Col>
						<Col lg={{ order: 2, span: 10 }} xs={{ order: 1 }}>
							<img className="topo-produto" src={this.state.logoUnicoEletricos}></img>
						</Col>
					</Row>
				</div>

				<section>
					<div className="unimake-container">
						<div className="content-area-product">
							<div className="pre-description-center">
								<p>
									Hoje em dia o varejo é muito competitivo em todos os setores, e no de materiais
									elétricos não é diferente.
								</p>
								<p>
									Não fique para trás da concorrência, com o Único ERP você gerencia sua loja de forma
									100% eficaz e ganha tempo para tomar as decisões mais importantes rumo ao futuro.
								</p>
							</div>

							<br />

							<div className="featuresBox">
								<Row>
									<Col sm={24}>
										<h3 style={{ fontSize: 32, fontWeight: 400 }}>
											Veja o que o Único ERP pode fazer pela sua loja de materiais elétricos:
										</h3>
									</Col>
								</Row>

								<Row justify="space-between">
									<Col sm={11} md={7}>
										<b>Cadastro de códigos alternativos:</b>
										<p>
											Possibilita vincular vários códigos de fabricantes e fornecedores a um mesmo
											produto, facilitando sua localização.
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Simulação do preço de venda</b>
										<p>
											O vendedor pode simular em tempo real a lucratividade dos itens do pedido e
											verificar qual faixa de preço pode praticar
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Venda rápida</b>
										<p>
											O vendedor lança os itens de acordo com as requisições do cliente e informa
											as condições de pagamento no fechamento
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Controle de comissões</b>
										<p>Permite parametrizar por vendedor, por produto ou por faixa de descontos</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Manuseio de produtos por código de barras</b>
										<p>
											Integra o software ao leitor de código de barras (fixo ou pistola) que lê os
											códigos de barras do produto no ato de recepção e saída de produtos
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Endereçamento de produtos no estoque</b>
										<p>
											Ao fazer a consulta de um produto no Único o usuário é informado do corredor
											e a prateleira em que o produto se encontra dentro do depósito
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Controle de estoque mínimo/máximo</b>
										<p>
											O Único alerta o gestor de compras quando um produto atinge o estoque
											mínimo, bem como avisa em caso de excesso de estoque de um determinado item
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Análise de crédito e bloqueio automático</b>
										<p>
											O software faz análise constante do histórico de credito dos clientes
											liberando ou bloqueando crédito conforme parâmetros determinados pelo
											financeiro
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Controle de cheques pré-datados</b>
										<p>
											Controla origem e destino dos cheques recebidos permitindo vincular cheques
											de terceiros ao cliente pagador e prazos de depósito
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Controle de acesso de usuários</b>
										<p>
											Permite parametrizar as permissões que cada usuário terá dentro do software
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Controle financeiro total</b>
										<p>
											Controles de caixa e contas bancárias Recebimentos com cartão Controle de
											pagamentos Emissão e baixa automática de boletos Bancários
										</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Contabilidade e escrita fiscal e SPED</b>
										<p>Para que sua empresa cumpra todas as Exigências fiscais vigentes</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Documentos Fiscais Eletrônicos</b>
										<p>Emita NF-e, NFC-e, S@T, CT-e, CC-e, MDF-e em regularidade com o fisco.</p>
									</Col>

									<Col sm={11} md={7}>
										<b>Integração com BI</b>
										<p>
											Agregando os módulos de BI e FV da Unimake você turbina a gestão do seu
											negócio{" "}
										</p>
										<Link to="/produtos/bi">Saiba mais</Link>
									</Col>

									<Col sm={11} md={7}>
										<b>Relatórios gerenciais</b>
										<p>
											Uma ampla gama de relatórios que permitem sua análise das operações tais
											como estoques, contas a pagar e receber, lucratividade entre outros.
										</p>
									</Col>
								</Row>
							</div>

							<br />

							<div className="imageMiddle-unmatele">
								<LazyLoad>
									<img
										style={{
											maxWidth: "70%",
											marginRight: "auto",
											marginLeft: "auto",
											display: "block",
										}}
										src={require("../../assets/img/products/auto/notebook-danfe.png")}
										alt=""
									/>
								</LazyLoad>
							</div>

							<br />
						</div>
					</div>
				</section>

				<div className="autoPecasBanner">
					<div className="autoPecasBanner-container">
						<Row align="middle">
							<Col xs={24} sm={24} md={{ span: 10, offset: 2 }}>
								<LazyLoad>
									<img
										className="imageLeft-fec"
										src={require("../../assets/img/products/eletrico/middle.png")}
									/>
								</LazyLoad>
							</Col>

							<Col xs={24} sm={24} md={10} lg={10}>
								<p className="imageLeft-Text-fec" style={{ color: "#238883" }}>
									Exerça a gestão total da sua autopeças com o Único ERP.
								</p>
								<p className="imageLeft-Text-fec" style={{ color: "#238883" }}>
									Sua equipe, seus clientes e seus lucros vão agradecer.
								</p>
							</Col>
							<Col className="hidden-sm hidden-xs" md={2} lg={2}></Col>
						</Row>
					</div>
				</div>

				{/* <div>
					<Row>
						<Col sm={24} md={24}>
							<h1 style={{ fontSize: 32, fontWeight: 300, textAlign: "center" }}>
								Alguns casos de sucesso
							</h1>

							<div style={{ height: 200 }}>
								<UmkSliderContainer />
							</div>
						</Col>
					</Row>
				</div> */}

				<ContatoComponent />
			</>
		);
	}
}
export default UnicoMaterialEletricoPage;
